import React from 'react';

// Card with an icon + title header, used for each section of the Profile page.
export default function SectionCard({
  Icon, title, subtitle, children, footer, bodyless,
}) {
  return (
    <section className='profile-card'>
      <header className='profile-card-header'>
        {Icon ? <span className='section-icon'><Icon /></span> : null}
        <div>
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </header>
      {bodyless ? children : <div className='profile-card-body'>{children}</div>}
      {footer ? <div className='profile-card-footer'>{footer}</div> : null}
    </section>
  );
}
